module.exports = __webpack_public_path__ + "static/img/bg-fr.fbd8cf09.png";